import React, {ReactNode} from "react"
import Button, {ButtonProps} from "../Button/Button"
import classNames from "classnames"

export type IconButtonProps = {
	size?: ButtonProps["size"]
	theme?: ButtonProps["theme"]
	variant?: ButtonProps["variant"]
	loading?: ButtonProps["loading"]
	icon: ButtonProps["prefixIcon"]
	tooltip?: ButtonProps["tooltip"]
	tooltipKey?: ButtonProps["tooltipKey"]
	tooltipDisabled?: ButtonProps["tooltipDisabled"]
	tooltipClassName?: ButtonProps["tooltipClassName"]
	tooltipPlace?: ButtonProps["tooltipPlace"]
	disabled?: ButtonProps["disabled"]
	onClick: ButtonProps["onClick"]
	className?: ButtonProps["className"]
	withIndicator?: boolean
	children?: ReactNode
}

export function IconButton({
	size,
	theme,
	variant,
	loading,
	icon,
	tooltip,
	tooltipKey,
	tooltipDisabled,
	tooltipClassName,
	tooltipPlace,
	disabled,
	onClick,
	className,
	withIndicator,
}: IconButtonProps) {
	return (
		<span className="icon-button-container">
			<Button
				size={size}
				theme={theme}
				variant={variant}
				loading={loading}
				disabled={disabled}
				onClick={onClick}
				prefixIcon={icon}
				circular
				tooltip={tooltip}
				tooltipKey={tooltipKey}
				tooltipDisabled={tooltipDisabled}
				tooltipClassName={tooltipClassName}
				tooltipPlace={tooltipPlace}
				className={classNames(className, "icon-button")}
			/>
			{withIndicator && <div className="indicator-dot" />}
		</span>
	)
}

export default IconButton
